export type AnimeCategory = 'healing' | 'daily' | 'moe';

export interface Anime {
  id: string;
  title: string;
  category: AnimeCategory;
  tags: string[];
  year: number;
  episodes: string;
  rating: number;
  status: string;
  synopsis: string;
  image: string;
  hot?: boolean;
  niche?: boolean;
}

export const animeList: Anime[] = [
  {
    id: 'natsume',
    title: '夏目友人帐',
    category: 'healing',
    tags: ['温馨', '妖怪', '清新'],
    year: 2008,
    episodes: '全6季',
    rating: 9.4,
    status: '连载',
    synopsis: '少年夏目贵志能看见妖怪，继承了祖母的友人帐后，与守护猫咪老师一起踏上归还妖怪名字的旅途，在一次次相遇中治愈他人也治愈自己。',
    image: 'https://readdy.ai/api/search-image?query=gentle%20anime%20illustration%20of%20a%20boy%20and%20a%20round%20white%20cat%20spirit%20walking%20through%20a%20green%20summer%20countryside%20field%20at%20golden%20hour%2C%20warm%20soft%20light%2C%20healing%20slice%20of%20life%20atmosphere%2C%20soft%20pastel%20colors%2C%20painterly%20anime%20background%20art&width=600&height=800&seq=anime-natsume&orientation=portrait',
    hot: true,
  },
  {
    id: 'yuru-camp',
    title: '摇曳露营△',
    category: 'daily',
    tags: ['露营', '治愈', '轻松'],
    year: 2018,
    episodes: '全3季',
    rating: 9.2,
    status: '完结',
    synopsis: '几位少女在富士山脚下结缘于露营，从搭建帐篷、生火做饭到星空下的闲聊，把户外生活的惬意与友情铺陈得温暖又治愈。',
    image: 'https://readdy.ai/api/search-image?query=anime%20illustration%20of%20a%20girl%20with%20pink%20hair%20camping%20by%20a%20lakeside%20at%20sunset%20with%20a%20campfire%20and%20a%20cup%20of%20hot%20cocoa%2C%20starry%20evening%20sky%2C%20warm%20cozy%20outdoor%20healing%20atmosphere%2C%20soft%20anime%20art%20style&width=600&height=800&seq=anime-yuru-camp&orientation=portrait',
    hot: true,
  },
  {
    id: 'violet',
    title: '紫罗兰永恒花园',
    category: 'healing',
    tags: ['催泪', '成长', '暖心'],
    year: 2018,
    episodes: '13话+剧场版',
    rating: 9.0,
    status: '完结',
    synopsis: '曾为兵器的少女薇尔莉特，在成为自动手记人偶后，通过替人书写信件一点点理解“爱”的含义，画面华丽，情感细腻动人。',
    image: 'https://readdy.ai/api/search-image?query=anime%20illustration%20of%20a%20young%20woman%20with%20golden%20braided%20hair%20standing%20by%20a%20window%20with%20sunlight%20streaming%20in%2C%20letters%20floating%20in%20the%20air%2C%20warm%20glowing%20light%2C%20emotional%20healing%20atmosphere%2C%20soft%20painterly%20anime%20art%20style&width=600&height=800&seq=anime-violet&orientation=portrait',
    hot: true,
  },
  {
    id: 'usagi-drop',
    title: '白兔糖',
    category: 'healing',
    tags: ['家庭', '温馨', '暖心'],
    year: 2011,
    episodes: '11话',
    rating: 8.7,
    status: '完结',
    synopsis: '大龄单身的河地大吉在祖父葬礼上收养了年仅六岁的鹿贺凛，两个性格迥异的人从陌生到相依，把平凡日子过得温柔有光。',
    image: 'https://readdy.ai/api/search-image?query=warm%20anime%20illustration%20of%20a%20gentle%20adult%20man%20carrying%20a%20small%20girl%20in%20a%20yellow%20dress%20on%20his%20back%20during%20autumn%20with%20falling%20leaves%2C%20cozy%20family%20slice%20of%20life%2C%20soft%20warm%20sunlight%2C%20healing%20atmosphere%2C%20soft%20anime%20art%20style&width=600&height=800&seq=anime-usagi&orientation=portrait',
    hot: true,
  },
  {
    id: 'mushishi',
    title: '虫师',
    category: 'healing',
    tags: ['奇幻', '安静', '清新'],
    year: 2005,
    episodes: '全2季',
    rating: 9.3,
    status: '完结',
    synopsis: '虫师银古游历各地，为被“虫”困扰的人们解开心结。故事节奏舒缓、意境悠远，适合夜深人静时慢慢品味。',
    image: 'https://readdy.ai/api/search-image?query=anime%20illustration%20of%20a%20calm%20silver%20haired%20traveler%20with%20a%20walking%20stick%20in%20a%20misty%20forest%20at%20dusk%2C%20glowing%20green%20spirits%20floating%20around%2C%20mysterious%20quiet%20nature%20atmosphere%2C%20muted%20soft%20colors%2C%20anime%20art%20style&width=600&height=800&seq=anime-mushishi&orientation=portrait',
    niche: true,
  },
  {
    id: 'momo',
    title: '给桃子的信',
    category: 'healing',
    tags: ['催泪', '亲情', '清新'],
    year: 2012,
    episodes: '剧场版',
    rating: 8.9,
    status: '完结',
    synopsis: '女孩桃子搬回海边的老家，思念离世的父亲，却在夏天遇到了三个从天而降的妖怪伙伴，在欢闹与感伤中慢慢告别悲伤。',
    image: 'https://readdy.ai/api/search-image?query=anime%20illustration%20of%20a%20young%20girl%20watching%20the%20summer%20ocean%20from%20a%20small%20island%20with%20three%20little%20spirit%20creatures%2C%20bright%20sky%2C%20warm%20sunlight%2C%20healing%20nostalgic%20atmosphere%2C%20soft%20anime%20art%20style&width=600&height=800&seq=anime-momo&orientation=portrait',
    niche: true,
  },
  {
    id: 'barakamon',
    title: '元气囝仔',
    category: 'healing',
    tags: ['成长', '搞笑', '暖心'],
    year: 2014,
    episodes: '12话',
    rating: 9.0,
    status: '完结',
    synopsis: '年轻书法家半田清舟因顶撞长辈被“发配”到海边的五岛，却在小岛村民与活泼孩子们的包围下，重新找回书法的初心。',
    image: 'https://readdy.ai/api/search-image?query=anime%20illustration%20of%20a%20young%20calligrapher%20sitting%20on%20a%20seaside%20terrace%20in%20summer%20writing%20calligraphy%20with%20an%20ocean%20view%2C%20bright%20sunny%20day%2C%20warm%20cheerful%20healing%20atmosphere%2C%20soft%20anime%20art%20style&width=600&height=800&seq=anime-barakamon&orientation=portrait',
    hot: true,
  },
  {
    id: 'nichijou',
    title: '日常',
    category: 'daily',
    tags: ['搞笑', '无厘头', '轻松'],
    year: 2011,
    episodes: '26话',
    rating: 9.1,
    status: '完结',
    synopsis: '东云研究所与相生祐子一家的“不日常日常”，脑洞大开、笑点密集，把平凡校园生活折腾出无数名场面。',
    image: 'https://readdy.ai/api/search-image?query=playful%20anime%20illustration%20of%20two%20schoolgirls%20doing%20a%20comedic%20stunt%20in%20a%20bright%20sunny%20schoolyard%2C%20cheerful%20gag%20comedy%20daily%20life%2C%20bright%20warm%20colors%2C%20soft%20anime%20art%20style&width=600&height=800&seq=anime-nichijou&orientation=portrait',
    hot: true,
  },
  {
    id: 'k-on',
    title: '轻音少女',
    category: 'daily',
    tags: ['音乐', '萌系', '轻松'],
    year: 2009,
    episodes: '全2季',
    rating: 8.9,
    status: '完结',
    synopsis: '濒临废部的轻音部迎来天然呆吉他手唯，四个女孩从喝茶聊天到登台演出，把青春日常过成了治愈的日常乐章。',
    image: 'https://readdy.ai/api/search-image?query=anime%20illustration%20of%20four%20cute%20schoolgirls%20in%20sailor%20uniforms%20playing%20guitars%20in%20a%20music%20club%20room%2C%20warm%20afternoon%20light%2C%20cheerful%20moe%20slice%20of%20life%2C%20soft%20pastel%20anime%20art%20style&width=600&height=800&seq=anime-kon&orientation=portrait',
    hot: true,
  },
  {
    id: 'non-non-biyori',
    title: '悠哉日常大王',
    category: 'daily',
    tags: ['乡村', '治愈', '轻松'],
    year: 2013,
    episodes: '全3季',
    rating: 9.0,
    status: '完结',
    synopsis: '转学而来的东京女孩萤，来到只有五位学生的旭丘分校，在乡野四季的更迭里，体会慢节奏的悠然时光。',
    image: 'https://readdy.ai/api/search-image?query=anime%20illustration%20of%20a%20small%20schoolgirl%20with%20a%20red%20cap%20standing%20in%20a%20vast%20green%20rural%20countryside%20with%20a%20butterfly%20and%20tiny%20animals%2C%20serene%20peaceful%20daily%20life%2C%20soft%20bright%20colors%2C%20healing%20anime%20art%20style&width=600&height=800&seq=anime-nonnon&orientation=portrait',
    hot: true,
  },
  {
    id: 'daily-boys',
    title: '男子高中生的日常',
    category: 'daily',
    tags: ['搞笑', '校园', '轻松'],
    year: 2012,
    episodes: '12话',
    rating: 8.8,
    status: '完结',
    synopsis: '三名高中男生放学后的日常脑洞与胡闹，用一本正经的口气讲着毫无逻辑的段子，笑到肚子疼。',
    image: 'https://readdy.ai/api/search-image?query=funny%20anime%20illustration%20of%20three%20high%20school%20boys%20sitting%20on%20a%20riverbank%20talking%20about%20nonsense%20at%20evening%20sunset%2C%20comedic%20slice%20of%20life%2C%20warm%20bright%20colors%2C%20soft%20anime%20art%20style&width=600&height=800&seq=anime-dailyboys&orientation=portrait',
  },
  {
    id: 'nozaki',
    title: '月刊少女野崎君',
    category: 'daily',
    tags: ['恋爱', '搞笑', '轻松'],
    year: 2014,
    episodes: '12话',
    rating: 8.9,
    status: '完结',
    synopsis: '少女佐仓向暗恋的野崎告白，却意外成了他的漫画助手。少女漫画家与身边的人一起，把恋爱喜剧拍成了搞笑日常。',
    image: 'https://readdy.ai/api/search-image?query=cute%20anime%20illustration%20of%20a%20tall%20boy%20and%20a%20small%20girl%20walking%20together%20carrying%20a%20mangaka%20sketchbook%20in%20a%20colorful%20school%20setting%2C%20comedic%20romantic%20daily%20life%2C%20warm%20pastel%20anime%20art%20style&width=600&height=800&seq=anime-nozaki&orientation=portrait',
  },
  {
    id: 'luo-xiaohei',
    title: '罗小黑战记',
    category: 'moe',
    tags: ['萌系', '奇幻', '治愈'],
    year: 2011,
    episodes: '番剧+剧场版',
    rating: 9.5,
    status: '连载',
    synopsis: '小黑是一只拥有空间能力的小黑猫，在人类城市中与谛听、无限等伙伴相遇，软萌的外表下藏着温暖又冒险的故事。',
    image: 'https://readdy.ai/api/search-image?query=cute%20anime%20illustration%20of%20a%20little%20black%20cat%20with%20a%20big%20green%20tail%20standing%20in%20a%20bright%20modern%20city%20park%2C%20daytime%2C%20adorable%20moe%20animation%20style%2C%20soft%20warm%20colors&width=600&height=800&seq=anime-luoxiaohei&orientation=portrait',
    hot: true,
  },
  {
    id: 'rilakkuma',
    title: '轻松熊和小薰',
    category: 'moe',
    tags: ['萌系', '温馨', '轻松'],
    year: 2019,
    episodes: '全2季',
    rating: 8.6,
    status: '完结',
    synopsis: '独居上班族小薰与三只毛绒伙伴的日常，用定格动画的细腻质感，把都市生活的孤单与温暖揉进每一帧。',
    image: 'https://readdy.ai/api/search-image?query=adorable%20anime%20illustration%20of%20a%20tan%20round%20bear%20plush%20relaxing%20on%20a%20sofa%20in%20a%20cozy%20living%20room%20with%20warm%20lamps%2C%20calm%20gentle%20daily%20life%2C%20soft%20warm%20pastel%20anime%20art%20style&width=600&height=800&seq=anime-rilakkuma&orientation=portrait',
    niche: true,
  },
  {
    id: 'red-bean',
    title: '请吃红小豆吧！',
    category: 'moe',
    tags: ['萌系', '搞笑', '轻松'],
    year: 2018,
    episodes: '全4季',
    rating: 8.8,
    status: '连载',
    synopsis: '一颗立志被吃掉的红小豆，在奶茶、冰沙和红豆沙里不断“打工”，用沙雕脑洞讲职场与生活，短小又上头。',
    image: 'https://readdy.ai/api/search-image?query=cute%20anime%20illustration%20of%20a%20round%20red%20bean%20character%20with%20a%20tiny%20smile%20riding%20a%20bubble%20inside%20a%20cup%20of%20milk%20tea%2C%20adorable%20playful%20kawaii%20anime%20art%20style%2C%20soft%20warm%20colors&width=600&height=800&seq=anime-redbean&orientation=portrait',
    niche: true,
  },
];

export function getByCategory(category: AnimeCategory): Anime[] {
  return animeList.filter((a) => a.category === category);
}

export const hotAnime = animeList.filter((a) => a.hot);
export const nicheAnime = animeList.filter((a) => a.niche);